import React from 'react';
import { AppButton, Box, Preloader, Text, WarningIcon } from '@common-fe/common-fe';

import { Modal } from '@/components';

interface HideServiceModalProps {
  visible: boolean;
  serviceName: string;
  isHiding: boolean;
  isLoading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const HideServiceModal: React.FC<HideServiceModalProps> = ({
  visible,
  serviceName,
  isHiding,
  isLoading,
  onClose,
  onConfirm,
}) => {
  const title = isHiding ? `Hide ${serviceName} Service?` : `Unhide ${serviceName} Service?`;

  const description = isHiding
    ? 'This service will disappear from manual claim form.'
    : 'This service will appear at manual claim form.';

  const confirmLabel = isHiding ? 'Yes, Hide' : 'Yes, Unhide';

  return (
    <Modal testId="hide-service-modal" visible={visible} onSetVisible={onClose}>
      <Box direction="column" margin={{ vertical: 'spacing24' }}>
        <Box direction="column" align="center" justify="center">
          <WarningIcon size="48px" color="warning" />
          <Text
            data-testid="hide-service-modal_title"
            size="2xl"
            weight={700}
            margin={{ vertical: 'spacing12' }}
          >
            {title}
          </Text>
        </Box>

        <Box margin={{ horizontal: 'spacing24' }}>
          <Text textAlign="center" data-testid="hide-service-modal_description">
            {description}
          </Text>
        </Box>

        <Box direction="row" align="center" justify="center" gap="spacing12" margin={{ top: 'spacing24' }}>
          <AppButton
            testId="hide-service-modal_cancel"
            buttonType="secondary"
            width="130px"
            onClick={onClose}
          >
            Cancel
          </AppButton>

          <AppButton
            testId="hide-service-modal_confirm"
            buttonType="primary"
            color="red"
            width="130px"
            disabled={isLoading}
            onClick={onConfirm}
          >
            {isLoading ? <Preloader color="white" /> : confirmLabel}
          </AppButton>
        </Box>
      </Box>
    </Modal>
  );
};

export default HideServiceModal;
